import { Draggable, Droppable } from "react-beautiful-dnd";

// @mui material components
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";

/**
 * Row and body components for components/DigiHapi/DataTable making rows
 * reorderable with react-beautiful-dnd (the table must be inside a DragDropContext).
 */

// Draggable row; rowInfo ({ original, index }) is provided by DataTable
export function DragTrComponent({ children = null, rowInfo }) {
	const { original, index } = rowInfo;
	return (
		<Draggable index={index} draggableId={original._id}>
			{(provided, snapshot) => (
				<TableRow
					ref={provided.innerRef}
					{...provided.draggableProps}
					{...provided.dragHandleProps}
					hover
					sx={{
						cursor: "grab",
						// Keep the cell layout while the row is detached from the table
						...(snapshot.isDragging && {
							display: "table",
							tableLayout: "fixed",
							backgroundColor: "white",
							boxShadow: 3
						})
					}}
				>
					{children}
				</TableRow>
			)}
		</Draggable>
	);
}

// Builds a droppable table body bound to the given droppableId
export function makeDropTbodyComponent(droppableId = "droppable") {
	return function DropTbodyComponent({ children = null, ...props }) {
		return (
			<Droppable droppableId={droppableId}>
				{provided => (
					<TableBody
						{...props}
						ref={provided.innerRef}
						{...provided.droppableProps}
					>
						{children}
						{/* The placeholder must live in a cell to keep a valid table DOM */}
						<tr>
							<td colSpan={100} style={{ padding: 0, border: 0 }}>
								{provided.placeholder}
							</td>
						</tr>
					</TableBody>
				)}
			</Droppable>
		);
	};
}

export const DropTbodyComponent = makeDropTbodyComponent("droppable");
